export default "__VITE_PUBLIC_ASSET__0afdda76__"